<template>
  <div class="userInfo">
    <div v-if="users.userInfo.authenticated">
      <el-row>
        <el-col :span="20">
          <span style="font-weight:900">欢迎您，</span>
          {{'*******' +users.userInfo.username.substr(7) }}
          &nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;
          <a
            @click="logout()"
          >
            <span style="color:red">
              <font-awesome-icon icon="sign-out-alt"/>退出登录
            </span>
          </a>
        </el-col>
        <el-col :span="4" style="text-align:right;color:red;padding-right:0.1rem">
          <a @click="close()">
            <font-awesome-icon icon="times" style="font-size:0.1rem"/>
          </a>
        </el-col>
      </el-row>
      <div style="margin-top:0.1rem">
        <span style="font-weight:900">充值余额：</span>
        <span>&nbsp;{{(Number(users.userInfo.account1)/100).toFixed(2)}}元</span>
        <span style="font-weight:900">&nbsp; &nbsp; &nbsp;赠送余额：</span>
        <span>&nbsp;{{(Number(users.userInfo.account2)/100).toFixed(2)}}元</span>
      </div>
    </div>
    <div v-else>
      <div style="text-align:left;padding:0.05rem 0;font-weight:900">{{users.userLogin.message}}</div>
      <el-row>
        <el-col :span="14" style="text-align:left;padding:0.05rem 0">新用户登录即自动注册,并表示已同意用户服务协议。</el-col>
        <el-col :span="10" style="text-align:right;padding:0.05rem 0">
          <a @click="showAgreement=true">服务协议及隐私保护说明</a>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input placeholder="请输入正确的手机号获取验证码" type="text" v-model="username">
            <el-button
              slot="append"
              :disabled="/^1[34578]\d{9}$/.test(username) == false || countdown != null"
              @click="sendSMS(username)"
              id="btn"
            >
              <span v-if="countdown">{{countdown}}</span>
              <span v-else>获取验证码</span>
            </el-button>
          </el-input>
        </el-col>
        <el-col :span="12">
          <el-input placeholder="请输入发送到您手机上的验证码" type="text" v-model="password">
            <el-button
              slot="append"
              @click="login(username,password)"
              :disabled="!/^\d{6}$/.test(password)"
            >登录</el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="showAgreement" style="text-align:left" :modal="false">
      <p style="font-weight:900">网站服务协议和隐私保护说明</p>
      <p>欢迎您使用 1DING GRC 平台（以下简称“本网站”）所提供的服务！</p>
      <p>为使用“本网站”讯的服务，您应当阅读并遵守本服务协议和隐私政策。请您务必审慎阅读、充分理解各条款内容。</p>
      <p>一、【帐号与密码安全】</p>
      <p>您在使用本服务时可能需要注册一个帐号。本网站特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受被盗号或密码失窃，责任由您自行承担。</p>
      <p>二、【个人隐私保护】</p>
      <p>一丁工作室非常重视对您的个人隐私的保护。在某些情况下我们需要您提供一些信息才能为您提供您请求的服务。请在向一丁工作室提交个人数据之前，阅读、了解本《隐私政策》（下文简称“本政策”）。</p>
      <p style="font-weight:900">本网站目前不收集、不保存任何个人敏感信息或个人隐私信息。</p>
      <p>目前所收集的信息，仅限于您的手机号，以及您曾经购买过的内容清单（以确保您可以多次下载您所购买的内容）。</p>
      <p>虽然我们保存了您的手机号，但我们并不知道机主是谁，叫什么、在哪个单位。</p>
      <p>本网站除需要通过您的手机号进行身份验证外，不收集任何其他信息，不收集您的姓名（包括您的真实姓名和网名），不收集您的工作单位，也不从您的设备（PC、手机、平板等）收集任何信息。</p>
      <p>虽然本网站可以通过微信进行支付，但我们并不知道，也不收集您的微信号。</p>
      <p>如果后续本网站所提供的服务，需要收集您更多的信息，本网站将及时公告，并在得到您的确认后再进行。</p>
      <p>三、【服务费用】</p>
      <p>本网站的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。</p>
      <p>一丁工作室可能根据实际需要对收费服务的收费标准、方式进行修改和变更，也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，一丁工作室将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。</p>
      <p>在一丁工作室降低收费服务的收费标准或者将收费服务改为免费服务提供时，保留不对原付费用户提供退费或者费用调整之权利。</p>
      <p style="text-align:right">一丁工作室</p>
      <p style="text-align:right">2019年3月18日</p>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/misc/bus.js";
export default {
  data() {
    return {
      username: "",
      password: "",
      countdown: null,
      showAgreement: false
    };
  },
  props: {
    users: Object
  },
  methods: {
    // 关闭用户信息显示
    close() {
      Bus.$emit("showUserCenter", false);
    },
    // 用户登录
    login() {
      this.$store.dispatch("users/login", {
        username: this.username,
        password: this.password
      });
    },
    logout() {
      this.$store.dispatch("users/logout");
      Bus.$emit("showUserCenter", false);
    },
    // 调用users中的sendSMS方法获取验证码
    sendSMS(username) {
      var self = this;
      self.countdown = 60;
      var t;

      function times() {
        self.countdown--;
        t = setTimeout(times, 1000);
        if (self.countdown == 0) {
          self.countdown = null;
          clearTimeout(t);
        }
      }
      times();
      self.$store.dispatch("users/sendSMS", username);
    }
  }
};
</script>

<style scoped>
.userInfo {
  padding-bottom: 0.1rem;
  text-align: left;
}
</style>

<style>
.userInfo .el-input__inner {
  font-size: 0.12rem !important;
  height: 0.5rem !important;
  line-height: 0.05rem !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  padding: 0.05rem 0.05rem !important;
}

.userInfo .el-input-group__append,
.userInfo .el-input-group__prepend {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>